import React from 'react';
import MoonLogo from './MoonLogo';
import MagicDust from './MagicDust';
import EventButton from './EventButton';

const TABS = [
  { id: 'sobre', label: 'Sobre Mí' },
  { id: 'libro', label: 'Mi Libro' },
  { id: 'tarot', label: 'Tarot' },
  { id: 'contacto', label: 'Contáctame' }
];

export default function Header({ active, onChange }) {
  return (
    <header className="w-full flex flex-col items-center pt-10 pb-2">
      <div className="mb-3 animate-[breathe_6s_ease-in-out_infinite]">
        <MagicDust width={60}>
          <MoonLogo size={54} />
        </MagicDust>
      </div>
      <h1 className="font-serif-display tracking-[0.22em] text-[2.3rem] md:text-[3rem] text-center font-normal luna-title">
        <span className="luna-title-text">LA LUNA QUE LADRA</span>
        <span className="luna-sparkles" aria-hidden="true">
          {Array.from({ length: 10 }).map((_, i) => (
            <span key={i} className={`luna-spark s${i}`} />
          ))}
        </span>
      </h1>
      <div className="h-[1.5px] w-40 md:w-56 mt-2 bg-gradient-to-r from-transparent via-[#b89dd4] to-transparent" />

      <div className="mt-5">
        <EventButton />
      </div>

      <nav className="mt-7 flex flex-wrap justify-center gap-3 md:gap-4">
        {TABS.map((t) => {
          const isActive = active === t.id;
          return (
            <button
              key={t.id}
              onClick={() => onChange(t.id)}
              className={[
                'px-6 py-2.5 rounded-full text-[0.82rem] tracking-[0.18em] uppercase font-medium',
                'transition-[background-color,color,box-shadow,transform] duration-300 ease-out',
                isActive
                  ? 'bg-gradient-to-r from-[#cdb2e0] to-[#b89dd4] text-white shadow-[0_8px_18px_-6px_rgba(155,120,190,0.55)]'
                  : 'bg-[#f6e6d4] text-[#6b4f3a] hover:bg-[#efd7bc] hover:-translate-y-[1px]'
              ].join(' ')}
            >
              {t.label}
            </button>
          );
        })}
      </nav>
    </header>
  );
}
